// index.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import { Box } from '@mui/material'
import { connect } from 'react-redux'
import { AppThunkDispatch, RootState } from '../../../redux'
import SelectCompanyDropdown from '../../SelectCompanyDropdown'
import { setSelectedCompany } from '../../../redux/company/thunks'
import UserMenu from './UserMenu'
import { setRefreshRate } from '../../../redux/upgradeMonitoring/slice'
import { defaultDropdownValue } from '../../Dropdown'
import { companyChange } from '../../../redux/globalActions'

function mapDispatchToProps(dispatch: AppThunkDispatch) {
  return {
    dispatchSetSelectedCompany: (...args: Parameters<typeof setSelectedCompany>) => dispatch(setSelectedCompany(...args)),
    dispatchSetRefreshRate: (...args: Parameters<typeof setRefreshRate>) => dispatch(setRefreshRate(...args)),
    dispatchResetStateForCompanyChange: (...args: Parameters<typeof companyChange>) => dispatch(companyChange(...args))
  }
}

function mapStateToProps(state: RootState) {
  return {
    user: state.user
  }
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type AppBarProps = StateProps & DispatchProps;

export function Appbar(
  {
    user,
    dispatchSetSelectedCompany,
    dispatchSetRefreshRate,
    dispatchResetStateForCompanyChange
  }: AppBarProps
): JSX.Element {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      width="100%"
      height="100%"
      gap={2}
      sx={{
        bgcolor: '#FFFFFF',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        paddingLeft: '24px',
        paddingRight: '24px'
      }}
    >
      <Box width="250px" display="flex">
        <SelectCompanyDropdown
          width="100%"
          disableUnderline
          onChange={(_e, value) => {
            if (user.userId !== null
              && user.sessionId !== null
              && user.dataCenter !== null
              && value) {
              dispatchResetStateForCompanyChange()
              dispatchSetSelectedCompany({
                userId: user.userId, sessionId: user.sessionId, dataCenter: user.dataCenter, company: value
              })
              dispatchSetRefreshRate(defaultDropdownValue)
            }
          }}
        />
      </Box>
      <UserMenu />
    </Box>
  )
}
export default connect(null, mapDispatchToProps)(Appbar)
